import { render, staticRenderFns } from "./OrderDatePage.vue?vue&type=template&id=51c90f08&scoped=true&"
import script from "./OrderDatePage.vue?vue&type=script&lang=js&"
export * from "./OrderDatePage.vue?vue&type=script&lang=js&"
import style0 from "./OrderDatePage.vue?vue&type=style&index=0&id=51c90f08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c90f08",
  null
  
)

export default component.exports